// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
  $w("#repeater1").onItemReady(($item, itemData, index) => {
    const ribbonText = itemData.featured_ribbon;

    // Optional: Log to confirm if the value is coming through
    console.log(`Item ${index} - Ribbon Text:`, ribbonText);

    if (ribbonText && ribbonText.trim() !== "") {
      $item("#ribbonText").text = ribbonText;
      $item("#ribbonBox").expand(); // 👈 Use .expand() instead of .show()
    } else {
      $item("#ribbonBox").collapse(); // Hides if no ribbon text
    }
  });
});


export function button7_click(event) {
	//Add your code for this event here: 
}

export function button7_click_1(event) {
	//Add your code for this event here: 
}

